import React from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SEVERITY_COLORS = {
	'critical': 'danger',
	'error': 'danger',
	'warning': 'warning',
	'info': 'info'
};

const StatsAnomaliesDisplay = ({ anomalies, summary }) => {
	const hasAnomalies = anomalies && anomalies.length > 0;
	const hasSummary = summary && Object.keys(summary).length > 0;

	if (!hasAnomalies && !hasSummary) {
		return (
			<Card className='shadow-sm mb-3 card-border'>
				<Card.Body className='text-center'>
					<i className='bi bi-check-circle text-success fs-3'></i>
					<p className='mt-2 mb-0'>No anomalies detected</p>
				</Card.Body>
			</Card>
		);
	}

	return (
		<>
			{hasSummary &&
				<Card className='shadow-sm mb-3 card-border'>
					<Card.Body>
						<Card.Title as='h6'>Overall Analysis</Card.Title>
						<div className='d-flex flex-wrap gap-3 mb-2'>
							<div>
								<small className='text-muted'>Current Rate</small>
								<p className='mb-0'><strong>{summary.current_rate_per_minute}</strong> jobs/min</p>
							</div>
							<div>
								<small className='text-muted'>24h Avg Rate</small>
								<p className='mb-0'><strong>{summary.avg_rate_24h_per_minute}</strong> jobs/min</p>
							</div>
							<div>
								<small className='text-muted'>Deviation</small>
								<p className='mb-0'>
									<strong style={{ color: Math.abs(summary.deviation_from_avg_percent) > 50 ? '#dc3545' : '#198754' }}>
										{summary.deviation_from_avg_percent > 0 ? '+' : ''}{summary.deviation_from_avg_percent}%
									</strong>
								</p>
							</div>
							<div>
								<small className='text-muted'>Error Rate (1h)</small>
								<p className='mb-0'>
									<strong style={{ color: summary.error_rate_1h > 5 ? '#dc3545' : '#198754' }}>
										{summary.error_rate_1h}%
									</strong>
								</p>
							</div>
						</div>
						{summary.is_traffic_anomaly && <Badge bg='warning' className='me-2'>Traffic Anomaly: {summary.traffic_anomaly_type}</Badge>}
						{summary.is_error_anomaly && <Badge bg='danger' className='me-2'>Error Anomaly</Badge>}
						{summary.is_response_time_anomaly && <Badge bg='warning' className='me-2'>Response Time Anomaly</Badge>}

						{summary.recommendations && summary.recommendations.length > 0 &&
							<div className='mt-3'>
								<small className='text-muted'>Recommendations</small>
								<ListGroup variant='flush'>
									{summary.recommendations.map((rec, idx) => (
										<ListGroup.Item key={idx} className='py-1 px-0 border-0'>
											<i className='bi bi-arrow-right me-2 text-primary'></i>{rec}
										</ListGroup.Item>
									))}
								</ListGroup>
							</div>
						}
					</Card.Body>
				</Card>
			}

			{hasAnomalies &&
				<Card className='shadow-sm mb-3 card-border'>
					<Card.Body>
						<Card.Title as='h6'>Hourly Anomalies ({anomalies.length})</Card.Title>
						<ListGroup variant='flush'>
							{anomalies.map((anomaly, idx) => (
								<ListGroup.Item key={idx} className='d-flex justify-content-between align-items-center'>
									<div>
										<strong>{anomaly.hour}</strong>
										<span className='ms-2 text-muted'>{anomaly.type?.replace('_', ' ')}</span>
										{anomaly.value !== undefined && <span className='ms-2'>Value: {anomaly.value}</span>}
										{anomaly.error_rate !== undefined && <span className='ms-2'>Error Rate: {anomaly.error_rate?.toFixed(1)}%</span>}
									</div>
									<Badge bg={SEVERITY_COLORS[anomaly.severity] || 'secondary'}>
										{anomaly.severity}
									</Badge>
								</ListGroup.Item>
							))}
						</ListGroup>
					</Card.Body>
				</Card>
			}
		</>
	);
}

StatsAnomaliesDisplay.propTypes = {
	anomalies: PropTypes.array,
	summary: PropTypes.object
}

export default StatsAnomaliesDisplay;
